import { Link } from "react-router-dom";
import { Calendar, CreditCard } from "lucide-react";

export default function BookingsTab({ bookings, user, payNow, updateBookingStatus, refundBooking }) {
  if (bookings.length === 0) {
    return (
      <div className="brut-card p-8 text-center" data-testid="bookings-list">
        <Calendar size={32} className="mx-auto"/>
        <div className="font-display font-black text-2xl mt-2">No bookings yet</div>
        <Link to="/properties" className="brut-btn mt-4 inline-flex">Browse PGs</Link>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="bookings-list">
      {bookings.map(b => (
        <div key={b.id} className="brut-card p-5 flex flex-wrap gap-4" data-testid={`booking-${b.id}`}>
          {b.property_image && <img src={b.property_image} className="w-32 h-24 object-cover brut-border" alt=""/>}
          <div className="flex-1 min-w-[200px]">
            <div className="font-display font-black text-xl">{b.property_title}</div>
            <div className="text-sm text-[#4A4A4A]">{b.room_name} · Move-in {b.move_in_date} · {b.duration_months}mo</div>
            <div className="flex gap-2 mt-2 flex-wrap">
              <span className={`brut-tag ${b.status==="confirmed"?"lime":b.status==="cancelled"?"pink":"white"}`}>{b.status}</span>
              <span className={`brut-tag ${b.payment_status==="paid"?"lime":"pink"}`}>{b.payment_status}</span>
              <span className="brut-tag white">₹{b.total_amount?.toLocaleString()}</span>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            {user.role === "student" && b.payment_status !== "paid" && (
              <button className="brut-btn !py-1 !px-3 !text-xs" onClick={()=>payNow(b)} data-testid={`pay-${b.id}`}><CreditCard size={14}/> Pay now</button>
            )}
            {user.role === "owner" && b.status === "pending_payment" && (
              <>
                <button className="brut-btn !py-1 !px-3 !text-xs" onClick={()=>updateBookingStatus(b.id, "confirmed")}>Confirm</button>
                <button className="brut-btn pink !py-1 !px-3 !text-xs" onClick={()=>updateBookingStatus(b.id, "cancelled")}>Cancel</button>
              </>
            )}
            {(user.role === "owner" || user.role === "admin") && b.payment_status === "paid" && b.status !== "refunded" && (
              <button className="brut-btn pink !py-1 !px-3 !text-xs" onClick={()=>refundBooking(b.id)} data-testid={`refund-${b.id}`}>Refund</button>
            )}
            {b.status === "refunded" && <span className="brut-tag white !text-[10px]">refunded</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
